import firebase from 'firebase/app'
import 'firebase/auth'

export function getFirebaseUserStatus () {
  return new Promise(function (resolve, reject) {
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        resolve(user)
      } else {
        reject(Error('It broke'))
      }
    })
  })
}
